module.exports = __webpack_public_path__ + "static/media/west_of_cedarhill-IG.297fe82b.PNG";